import { FORMS_CONSTANTS } from "@/modules/Forms/constants/FormsConstants";
import { ListSchema } from "@/modules/List/models/ListSchema";
import { FieldOrder } from "@/modules/Orders/models/FieldOrder";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  CUSTOM_FIELDS_LABELS_FORM,
  GENERAL_RULES_CONSTANTS,
  INPUT_TYPE
} from "../../constants/GeneralRulesConstants";
import { MedicalOrderField } from "@/modules/MedicalOrder/models/MedicalOrderField";
import { CustomFieldValue } from "../../models/CustomFieldValue.model";
import { TitleList } from "@/shared/models/TitleList";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import Vuetify from "vuetify";
import { PreventKey } from "@/shared/mixins/mixins";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";

Vue.use(Vuetify);
@Component({
  name: "Order",
  components: {
    DynamicSelect
  }
})
export default class CustomFieldsDisplay extends PreventKey {
  @Prop() field!: FieldOrder[];
  @Prop() fetchCustomFields!: boolean;
  @Prop() cleanCustomFields!: boolean;
  @Prop() edit!: boolean;
  @Prop() fieldsToEdit!: { [key: string]: MedicalOrderField };

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  SELECT = INPUT_TYPE.SELECT;
  selectedvalue: CustomFieldValue = new CustomFieldValue();
  list: ListSchema[] = [];
  orderFieldsList: string[] = [];
  fieldSelected: FieldOrder = new FieldOrder();
  SELECT_FIELD = GENERAL_RULES_CONSTANTS.SELECT_FIELD;
  CUSTOM_FIELDS_LABELS_FORM = CUSTOM_FIELDS_LABELS_FORM;
  customField: MedicalOrderField = new MedicalOrderField();
  itemsSelected = [] as string[];
  customFieldsToSave: { [key: string]: MedicalOrderField } = {};
  fieldsToShow: any[] = [];
  disabledPlusBtn = false;
  orderFieldListModel = [{ id: "", name: "" }];
  ListModel = [{ id: "", name: "" }];
  ListMultipleModel = [{ id: "", name: "" }];
  orderFieldSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.SELECT_FIELD,
    hideDetails: false
  };
  listSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    hideDetails: false
  };
  listMultipleSelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    hideDetails: false
  };
  editComparationStr = "";
  editDetected = false;
  mounted() {
    this.getFieldsToList();
  }

  get selectField() {
    return this.orderFieldListModel[0].id;
  }

  set selectField(value: string) {
    const option = this.orderFieldSelectConfig.listAll.find(
      item => item.id === value
    );
    this.orderFieldListModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }
  get selectList() {
    return this.ListModel[0].id;
  }

  set selectList(value: string) {
    const option = this.listSelectConfig.listAll.find(
      item => item.id === value
    );
    this.orderFieldListModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }

  get selectMultiList() {
    const filteredArray = this.ListMultipleModel.map(item => item.id);
    return filteredArray.filter(item => item !== null && item !== "");
  }

  set selectMultiList(value: string[]) {
    const option = this.listMultipleSelectConfig.listAll.find(
      (item: any) => item.id === value
    );
    this.ListMultipleModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }

  @Watch("ListMultipleModel")
  onListMultipleModelChanged() {
    this.itemsSelected = this.selectMultiList;
    if (this.itemsSelected.length > 0) {
      this.setfieldSelected(
        this.itemsSelected,
        this.fieldSelected.visualElement,
        this.fieldSelected.type
      );
    }
  }
  @Watch("customFieldsToSave", { deep: true })
  checkEdit() {
    if (this.edit) {
      this.editDetected =
        JSON.stringify(this.customFieldsToSave) === this.editComparationStr;

      this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.ORDER_CUSTOM_CHANGE, {
        equal: this.editDetected
      });
    }
  }
  @Watch("fieldsToEdit")
  listenFieldsToEdit() {
    if (this.edit) {
      this.customFieldsToSave = { ...this.fieldsToEdit };

      for (const value in this.fieldsToEdit) {
        this.fieldsToShow.push({ ...this.fieldsToEdit[value], key: value });
      }
      this.editComparationStr = JSON.stringify(this.customFieldsToSave);
    }
  }

  @Watch("field")
  getFieldsToList() {
    if (this.field.length > 0) {
      this.orderFieldsList = this.field.map(item => item.conversationTitle);
      this.orderFieldSelectConfig.listAll = this.field.map(item => {
        return { id: item.conversationTitle, name: item.conversationTitle };
      });
    }
  }

  setFieldToDisplay(field: string) {
    this.itemsSelected = [];
    this.list = [];
    const findField = this.field.find(item => item.conversationTitle === field);
    if (findField !== undefined) {
      const findFieldInSelected = this.fieldsToShow.find(
        item => item.key === findField.key
      );
      if (findFieldInSelected !== undefined) {
        Snackbar.popError(CUSTOM_FIELDS_LABELS_FORM.EXIST_FIELD);
        return;
      }
      this.disabledPlusBtn = false;
      this.fieldSelected = findField;
      if (this.fieldSelected.type === FORMS_CONSTANTS.FIELD_TYPE.LIST) {
        if (
          this.fieldSelected.visualElement === FORMS_CONSTANTS.FIELD.CHECKBOX
        ) {
          this.list = this.fieldSelected.schema.items!.oneOf! ?? [];
          this.listSelectConfig.listAll = this.list.map(item => {
            return { id: item.title, name: item.title };
          });
          this.listMultipleSelectConfig.listAll = this.listSelectConfig.listAll;
        } else {
          this.list = this.fieldSelected.schema.oneOf! ?? [];
          this.listSelectConfig.listAll = this.list.map(item => {
            return { id: item.title, name: item.title };
          });
          this.listMultipleSelectConfig.listAll = this.listSelectConfig.listAll;
        }
      }
    }
  }

  setfieldSelected(event: any, visualElement: string, type: string) {
    this.selectedvalue.value = "";
    this.selectedvalue.type = type;
    this.selectedvalue.value = event;
    this.selectedvalue.visualElement = visualElement;
  }

  addNewCustomField() {
    if (this.selectedvalue.type === CUSTOM_FIELDS_LABELS_FORM.LIST) {
      if (Array.isArray(this.selectedvalue.value)) {
        this.customField.titleSelectValue = this.selectedvalue.value.map(
          (item: string) => {
            const titleList = new TitleList();
            titleList.title = item;
            titleList.type = this.selectedvalue.visualElement;
            titleList.value = this.list.find(
              element => element.title === item
            )!.const;
            return titleList;
          }
        );

        this.customField.value = this.customField.titleSelectValue!.map(
          element => element.value
        ) as Array<string>;
      } else {
        const titleList = new TitleList();
        titleList.title = this.selectedvalue.value;
        titleList.type = this.selectedvalue.visualElement;

        titleList.value = this.list.find(
          element => element.title === this.selectedvalue.value
        )!.const;
        this.customField.titleSelectValue = [titleList];

        this.customField.value = titleList.value;
      }

      this.customField.scoreSelectValue = this.list[0].score;
      this.customField.listTemplate = this.fieldSelected.list;
    } else {
      this.customField.value = this.selectedvalue.value;
      delete this.customField.scoreSelectValue;
      delete this.customField.listTemplate;
      delete this.customField.titleSelectValue;
    }

    this.customField.title = this.fieldSelected.schema.title;

    this.customFieldsToSave[this.fieldSelected.key] = { ...this.customField };
    this.checkEdit();
    this.fieldsToShow.push({
      ...this.customFieldsToSave[this.fieldSelected.key],
      key: this.fieldSelected.key
    });
    this.disabledPlusBtn = true;
  }

  deleteField(item: any) {
    this.fieldsToShow = this.fieldsToShow.filter(
      element => element.key !== item.key
    );
    delete this.customFieldsToSave[item.key];
    this.checkEdit();
  }

  @Watch("fetchCustomFields")
  sendCustomFields() {
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.SEND_CUSTOM_FIELDS, {
      ...this.customFieldsToSave
    });
    for (const prop of Object.getOwnPropertyNames(this.customFieldsToSave)) {
      delete this.customFieldsToSave[prop];
    }
  }

  @Watch("cleanCustomFields")
  cleanFields() {
    for (const prop of Object.getOwnPropertyNames(this.customFieldsToSave)) {
      delete this.customFieldsToSave[prop];
    }
  }
}
